import { getPlatform, isNative } from './platform';
import { getDeviceId } from '@/services/push/deviceId';
import { ApiClient } from '@/services/api/client';

let reportedFor: string | null = null;

/**
 * Reporta el dispositivo del usuario al backend: plataforma (web/ios/android) y,
 * en apps nativas, la versión de la app. Best-effort, una vez por usuario y
 * sesión (se resetea si el reporte falla o cambia el usuario). Se llama al
 * autenticar desde el AuthContext.
 */
export async function reportDevice(userId: string): Promise<void> {
  if (reportedFor === userId) return;
  reportedFor = userId;
  try {
    const platform = getPlatform();
    let appVersion: string | undefined;
    if (isNative()) {
      try {
        const { App } = await import('@capacitor/app');
        const info = await App.getInfo();
        appVersion = info.version;
      } catch {
        /* getInfo no disponible → sin versión */
      }
    }
    await ApiClient.post('/users/me/device', {
      deviceId: getDeviceId(),
      platform,
      appVersion,
    });
  } catch {
    // Falló: permitimos reintentar en el próximo montaje.
    reportedFor = null;
  }
}
